"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.iconItemsConfig = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const getBriefcaseConfigItem = (count) => ({
    icon: 'briefcase',
    text: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/PriceVariant/TariffConfig/ConfigurationItem:HandBaggage', defaultMessage: '{count}x Hand baggage', values: { count } })),
});
const getBaggageConfigItem = (count) => ({
    icon: 'baggage',
    text: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/PriceVariant/TariffConfig/ConfigurationItem:Baggage', defaultMessage: '{count}x Baggage', values: { count } })),
});
exports.iconItemsConfig = {
    'meal': {
        icon: 'meal',
        text: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/PriceVariant/TariffConfig/ConfigurationItem:FoodAndDrinks', defaultMessage: 'Food & Drinks' })),
    },
    'briefcaseEconomy': getBriefcaseConfigItem(1),
    'baggageEconomy': getBaggageConfigItem(1),
    'briefcaseBusiness': getBriefcaseConfigItem(2),
    'baggageBusiness': getBaggageConfigItem(2),
    'fastlane': {
        icon: 'check-list',
        text: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/PriceVariant/TariffConfig/ConfigurationItem:FastLane', defaultMessage: 'Fast Lane' })),
    },
    'priorityBoarding': {
        icon: 'airplane',
        text: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/PriceVariant/TariffConfig/ConfigurationItem:PriorityBoarding', defaultMessage: 'Priority boarding' })),
    },
    'calendar-mark': {
        icon: 'calendar-mark',
        text: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/PriceVariant/TariffConfig/ConfigurationItem:BookFee', defaultMessage: 'Rebooking for a fee (Price difference possible)' })),
    },
    // economy-plus compatible
    'briefcase': getBriefcaseConfigItem(1),
    'baggage': getBaggageConfigItem(1),
};
//# sourceMappingURL=iconItemConfig.js.map